import React from 'react';
import './index.scss';
import { Input } from 'antd-mobile';

/**
 * 搜索栏组件的属性接口
 */
export interface IProps {
  /** 搜索框占位文本 */
  placeholder: string;
  /** 输入内容变化时的回调函数 */
  onChange: (value: string) => void;
  /** 按下回车键时的回调函数 */
  onEnterPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

/**
 * 搜索输入组件 - 使用传统函数声明以提高兼容性
 * @param props 组件属性
 */
const SearchInput = function (props: IProps) {
  // 保留const关键字，但避免使用解构赋值
  const placeholder = props.placeholder;
  const onChange = props.onChange;

  // 为可选属性提供默认值
  const onEnterPress =
    props.onEnterPress ||
    function () {
      // 默认空函数，不使用参数
    };

  // 处理输入变化的函数
  const handleChange = function (value: string) {
    onChange(value);
  };

  // 处理回车按键的函数
  const handleEnterPress = function (e: React.KeyboardEvent<HTMLInputElement>) {
    onEnterPress(e);
  };

  // 渲染组件
  return (
    <div className="search-bar">
      <div className="search-bar-wrapper">
        <i className="search-icon"></i>
        <Input
          placeholder={placeholder}
          onChange={handleChange}
          onEnterPress={handleEnterPress}
        />
      </div>
    </div>
  );
};

export default SearchInput;
